import {HeroBrandsSection_BrandElement} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/sections.types';
import {BrandElement} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation_page/sections.types';

/**
 * Maps a navigation_page `BrandElement` to a models `HeroBrandsSection_BrandElement`.
 *
 * The two types represent the same concept but live in different gRPC
 * packages. The main difference is that `BrandElement` carries extra
 * optional fields (`coverLandscapeVideo`, `coverPortraitVideo`, `sponsored`).
 */

const mapBrandElementContent = (
  content: BrandElement['content'],
): HeroBrandsSection_BrandElement['content'] => {
  if (!content) {
    return undefined;
  }

  if (content.$case === 'products') {
    return {
      $case: 'products' as const,
      products: {
        products: content.products.products,
        pill: content.products.pill,
        link: content.products.link,
        info: content.products.info,
      },
    };
  }

  return {
    $case: 'deferred' as const,
    deferred: content.deferred,
  };
};

export const mapBrandElement = (
  element: BrandElement,
): HeroBrandsSection_BrandElement & {
  coverLandscapeVideo?: BrandElement['coverLandscapeVideo'];
  coverPortraitVideo?: BrandElement['coverPortraitVideo'];
  sponsored?: BrandElement['sponsored'];
} => ({
  brand: element.brand,
  header: element.header,
  coverLandscapeImage: element.coverLandscapeImage,
  coverPortraitImage: element.coverPortraitImage,
  coverLandscapeVideo: element.coverLandscapeVideo,
  coverPortraitVideo: element.coverPortraitVideo,
  backgroundColorLandscape: element.backgroundColorLandscape,
  backgroundColorPortrait: element.backgroundColorPortrait,
  sponsored: element.sponsored,
  discoverMore: {
    coverImage: element.discoverMore.coverImage,
    headline: element.discoverMore.headline,
  },
  promotionTracker: element.promotionTracker,
  content: mapBrandElementContent(element.content),
});
